import styles from "./phodoLogos.module.scss";

interface LogoProps {
  size?: "tiny" | "small" | "medium" | "large" | "huge";
  className?: string;
}

const sizeClasses = {
  tiny: styles.sizeTiny,
  small: styles.sizeSmall,
  medium: styles.sizeMedium,
  large: styles.sizeLarge,
  huge: styles.sizeHuge
};

interface LogoWrapperProps extends LogoProps {
  children: React.ReactNode;
}

function LogoWrapper({ size = "medium", className, children }: LogoWrapperProps) {
  return (
    <div className={`${styles.wrapper} ${sizeClasses[size]}${className ? ` ${className}` : ""}`}>
      <svg
        viewBox="0 0 94 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.logoSvg}
      >
        {children}
      </svg>
    </div>
  );
}

export function LogoBW({ size = "medium", className }: LogoProps) {
  return (
    <LogoWrapper size={size} className={className}>
      <path
        d="M57.5682 15.129C59.0145 15.129 60.1868 13.9591 60.1868 12.5159C60.1868 11.0727 59.0145 9.90283 57.5682 9.90283C56.1221 9.90283 54.9497 11.0727 54.9497 12.5159C54.9497 13.9591 56.1221 15.129 57.5682 15.129Z"
        fill="#C5ADE6"
      />
      <path
        d="M45.1062 7.78564C40.6211 7.78564 36.9819 11.4171 36.9819 15.8928C36.9819 20.3686 40.6211 24 45.1062 24C49.5914 24 53.2305 20.3686 53.2305 15.8928C53.2171 11.4171 49.5914 7.78564 45.1062 7.78564ZM45.1062 19.8459C42.9173 19.8459 41.1448 18.0771 41.1448 15.8928C41.1448 13.7086 42.9173 11.9397 45.1062 11.9397C47.2951 11.9397 49.0677 13.7086 49.0677 15.8928C49.0677 18.0771 47.2951 19.8459 45.1062 19.8459Z"
        fill="black"
      />
      <path
        d="M85.8758 7.78564C81.3906 7.78564 77.7515 11.4171 77.7515 15.8928C77.7515 20.3686 81.3906 24 85.8758 24C90.3609 24 94 20.3686 94 15.8928C94 11.4171 90.3609 7.78564 85.8758 7.78564ZM85.8758 19.8459C83.6868 19.8459 81.9143 18.0771 81.9143 15.8928C81.9143 13.7086 83.6868 11.9397 85.8758 11.9397C88.0646 11.9397 89.8372 13.7086 89.8372 15.8928C89.8372 18.0771 88.0646 19.8459 85.8758 19.8459Z"
        fill="black"
      />
      <path
        d="M34.9014 15.8928V24H30.752V15.8928C30.752 13.7085 28.9795 11.9397 26.7905 11.9397C24.6017 11.9397 22.8291 13.7085 22.8291 15.8928V24H18.6797V0H22.8291V8.81742C23.9975 8.16081 25.3537 7.78559 26.7905 7.78559C31.2623 7.78559 34.9014 11.4171 34.9014 15.8928Z"
        fill="black"
      />
      <path
        d="M8.12429 0H0V24H4.16286V16.2144H8.12429C12.6094 16.2144 16.2486 12.5829 16.2486 8.10721C16.2486 3.61809 12.6094 0 8.12429 0ZM8.12429 12.0603H4.16286V4.1407H8.12429C10.3132 4.1407 12.0857 5.90955 12.0857 8.0938C12.0857 10.2781 10.3132 12.0603 8.12429 12.0603Z"
        fill="black"
      />
      <path
        d="M63.9864 0H55.4995V8.42881C56.1172 8.1072 56.8289 7.933 57.581 7.933C58.333 7.933 59.0312 8.1072 59.6624 8.42881V4.1407H63.9998C68.3506 4.1407 71.8689 7.65159 71.8689 11.9933C71.8689 16.335 68.3506 19.8459 63.9998 19.8459H59.6624V16.6164C59.0447 16.938 58.333 17.1122 57.581 17.1122C56.8289 17.1122 56.1306 16.938 55.4995 16.6164V24H63.9864C70.6335 24 76.0049 18.6265 76.0049 12.0067C76.0184 5.36013 70.6335 0 63.9864 0Z"
        fill="black"
      />
    </LogoWrapper>
  );
}

export function LogoColor({ size = "medium", className }: LogoProps) {
  return (
    <LogoWrapper size={size} className={className}>
      <path
        d="M57.4471 15.129C58.8902 15.129 60.0601 13.9591 60.0601 12.5159C60.0601 11.0727 58.8902 9.90283 57.4471 9.90283C56.0039 9.90283 54.834 11.0727 54.834 12.5159C54.834 13.9591 56.0039 15.129 57.4471 15.129Z"
        fill="#C5ADE6"
      />
      <path d="M45.0115 7.78564C40.5358 7.78564 36.9043 11.4171 36.9043 15.8928C36.9043 20.3686 40.5358 24 45.0115 24C49.4872 24 53.1187 20.3686 53.1187 15.8928C53.1053 11.4171 49.4872 7.78564 45.0115 7.78564ZM45.0115 19.8459C42.8273 19.8459 41.0584 18.0771 41.0584 15.8928C41.0584 13.7086 42.8273 11.9397 45.0115 11.9397C47.1958 11.9397 48.9646 13.7086 48.9646 15.8928C48.9646 18.0771 47.1958 19.8459 45.0115 19.8459Z" />
      <path d="M85.6951 7.78564C81.2194 7.78564 77.5879 11.4171 77.5879 15.8928C77.5879 20.3686 81.2194 24 85.6951 24C90.1708 24 93.8023 20.3686 93.8023 15.8928C93.8023 11.4171 90.1708 7.78564 85.6951 7.78564ZM85.6951 19.8459C83.5109 19.8459 81.742 18.0771 81.742 15.8928C81.742 13.7086 83.5109 11.9397 85.6951 11.9397C87.8794 11.9397 89.6482 13.7086 89.6482 15.8928C89.6482 18.0771 87.8794 19.8459 85.6951 19.8459Z" />
      <path d="M34.8272 15.8928V24H30.6865V15.8928C30.6865 13.7085 28.9176 11.9397 26.7334 11.9397C24.5491 11.9397 22.7803 13.7085 22.7803 15.8928V24H18.6396V0H22.7803V8.81742C23.9461 8.16081 25.2995 7.78559 26.7334 7.78559C31.1957 7.78559 34.8272 11.4171 34.8272 15.8928Z" />
      <path d="M8.10721 0H0V24H4.15411V16.2144H8.10721C12.5829 16.2144 16.2144 12.5829 16.2144 8.10721C16.2144 3.61809 12.5829 0 8.10721 0ZM8.10721 12.0603H4.15411V4.1407H8.10721C10.2915 4.1407 12.0603 5.90955 12.0603 8.0938C12.0603 10.2781 10.2915 12.0603 8.10721 12.0603Z" />
      <path d="M63.8528 0H55.3838V8.42881C56.0002 8.1072 56.7105 7.933 57.4609 7.933C58.2113 7.933 58.9081 8.1072 59.5379 8.42881V4.1407H63.8662C68.2079 4.1407 71.7188 7.65159 71.7188 11.9933C71.7188 16.335 68.2079 19.8459 63.8662 19.8459H59.5379V16.6164C58.9215 16.938 58.2113 17.1122 57.4609 17.1122C56.7105 17.1122 56.0136 16.938 55.3838 16.6164V24H63.8528C70.486 24 75.8461 18.6265 75.8461 12.0067C75.8595 5.36013 70.486 0 63.8528 0Z" />
    </LogoWrapper>
  );
}
